import { render, staticRenderFns } from "./KarvataDovozPage.vue?vue&type=template&id=28672343&scoped=true"
import script from "./KarvataDovozPage.vue?vue&type=script&lang=js"
export * from "./KarvataDovozPage.vue?vue&type=script&lang=js"
import style0 from "./KarvataDovozPage.vue?vue&type=style&index=0&id=28672343&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28672343",
  null
  
)

export default component.exports